import React from 'react';
import PropTypes from 'prop-types';
import withFormsCommonUI from '../../formsCommon/desktop/withFormsCommonUI';

class QuickFormPageContent extends React.Component {
  componentDidMount() {
    setTimeout(this.props.moveToFirstElement, 300);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.currentPage !== prevProps.currentPage) {
      setTimeout(this.props.moveToFirstElement, 300);
    }
  }

  render() {
    const { currentPage, generateForm, submitted } = this.props;

    return (
      <div className={'quickForm page_' + currentPage}>
        {generateForm(true, currentPage, submitted)}
      </div>
    );
  }
}

QuickFormPageContent.propTypes = {
  currentPage: PropTypes.number,
  generateForm: PropTypes.func,
  submitted: PropTypes.bool,
  moveToFirstElement: PropTypes.func
};

export default withFormsCommonUI(QuickFormPageContent);
